export default __webpack_public_path__ + "static/media/pictogramBeaconCalendar64.744d4dca.svg";